<script setup lang="ts">
import FotoActividad from '@frontend/secciones/components/foto-actividad.vue';

defineProps<{ actividad: { id: string; nombre: string; foto: string | null } }>();
const elegidas = defineModel<string[]>({ required: true });
</script>

<template>
  <label
    :data-testid="`opcion-${actividad.id}`"
    class="flex cursor-pointer flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm has-[:checked]:border-blue-600 has-[:checked]:ring-2 has-[:checked]:ring-blue-600"
  >
    <foto-actividad :actividad="actividad" />
    <span class="flex items-center gap-2 p-2 text-sm font-medium text-gray-900">
      <input v-model="elegidas" type="checkbox" :value="actividad.id" :data-testid="`elegir-${actividad.id}`" />
      {{ actividad.nombre }}
    </span>
  </label>
</template>
